import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";

import routes, { ROUTE_URLS } from "./routes";
import { ForgotPassword, Login } from "./pages";
import { CustomLayout } from "./components";
import { useSelector } from "react-redux";
import { useMe } from "./hooks";
import { canSeePage, getFirstAllowedPath } from "./navigation";
import { createLink } from "./utils";

export const App = () => {
  const { isGuest, isAdmin, pages, user } = useSelector((state) => state.authReducer);
  useMe();

  const getComponentForRoute = (route) => {
    if (isGuest) {
      return <Navigate replace to={ROUTE_URLS.LOGIN} />;
    }
    if (route.restricted && !isAdmin) {
      return <Navigate replace to={ROUTE_URLS.HOME} />;
    }
    if (route.page && !canSeePage(isAdmin, pages, route.page)) {
      const fallback = getFirstAllowedPath(isAdmin, pages) ?? createLink(ROUTE_URLS.EDIT_USER, user.id);
      return <Navigate replace to={fallback} />;
    }
    return (
      <CustomLayout route={route}>
        <route.component />
      </CustomLayout>
    );
  };

  return (
    <BrowserRouter basename="/">
      <React.Suspense>
        <Routes>
          <Route
            exact
            path={ROUTE_URLS.LOGIN}
            name="Login Page"
            element={
              isGuest ? <Login /> : <Navigate replace to={ROUTE_URLS.HOME} />
            }
          />
          <Route
            path={ROUTE_URLS.FORGOT_PASSWORD}
            element={
              isGuest ? <ForgotPassword /> : <Navigate replace to={ROUTE_URLS.HOME} />
            }
          />          {routes.map((route, i) => (
            <Route
              key={i}
              path={route.path}
              exact={route.exact}
              element={getComponentForRoute(route)}
            />
          ))}
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
};
